export default class Analytics {
  get MODAL_MENU() { return 'menu'; }
  get MODAL_PRESENTATION_FORM() { return 'presentation'; }
  get MODAL_PRESENTATION_VIDEO() { return 'presentation_video'; }
  get MODAL_APARTMENTS_VIEW_FORM() { return 'apartments_view'; }

  constructor() {
    this.activeModal = null;
    this.phones = document.querySelectorAll(`.js-phone`);
    this.residences = document.querySelectorAll(`.flats-types__toggle.js-slider-toggle`);
    this.mainVideo = document.querySelector(`.intro .screen__video`);
    this.presentationVideoLink = document.querySelector(`.page-footer__presentation`);
    this.menuButton = document.querySelector(`.page-header__menu`);
    this.menuLinks = document.querySelectorAll(`.modal__navigation-item`);
    this.modalCloseButton = document.querySelectorAll(`.modal__close`);
    this.presentationFormOpenLink = document.querySelector(`.page-footer__presentation.js-modal-form`);
    this.apartmentFormOpenLink = document.querySelector(`.page-footer__application.js-modal-form`);

    this.bindHandlers();
  }

  static init() {
    document.addEventListener(`DOMContentLoaded`, () => new Analytics);
  }

  static fireEvent(name) {
    console.log(`event ${name}`);

    if (typeof yaCounter28019928 !== 'undefined')
      yaCounter28019928.reachGoal(name);
  }

  event(name) {
    this.constructor.fireEvent(name);
  }

  bindHandlers() {
    this.phonesHandler();
    this.residencesHandler();
    this.mainVideoHandler();
    this.presentationVideoHandler();
    this.menuHandler();
    this.formOpenHandler();
    this.closeModalHandler();
  }

  phonesHandler() {
    this.phones.forEach((phone) => {
      phone.addEventListener(`click`, () => this.event('PhoneBClick'));
    });
  }

  residencesHandler() {
    this.residences.forEach((residence) => {
      residence.addEventListener(`click`, (e) => {
        switch (e.currentTarget.dataset.link) {
          case 'razumovskiy':
            this.event('RazumovskyClick');
            break;
          case 'volkonskiy':
            this.event('VolkonskyClick');
            break;
          case 'kushelev':
            this.event('KushelevClick');
            break;
        }
      });
    });
  }

  mainVideoHandler() {
    if (this.mainVideo !== null)
      this.mainVideo.addEventListener(`click`, () => {
        this.event('WatchMovieKB');
        this.event('PRCLICKVIDEO');
        this.activeModal = this.MODAL_PRESENTATION_VIDEO;
      });
  }

  presentationVideoHandler() {
    if (this.presentationVideoLink !== null)
      this.presentationVideoLink.addEventListener(`click`, () => {
        this.event('PRCLICKVIDEO');
        this.activeModal = this.MODAL_PRESENTATION_VIDEO;
      });
  }

  menuHandler() {
    this.menuButton.addEventListener(`click`, () => {
      this.event('BurgerClick');
      this.activeModal = this.MODAL_MENU;
    });

    this.menuLinks.forEach((link) => {
      link.addEventListener(`click`, () => this.event('MenuClick'));
      this.activeModal = null;
    });
  }

  formOpenHandler() {
    if (this.presentationFormOpenLink !== null)
      this.presentationFormOpenLink.addEventListener(`click`, () => {
        this.event('PresentationClick');
        this.activeModal = this.MODAL_PRESENTATION_FORM;
      });

    if (this.apartmentFormOpenLink !== null)
      this.apartmentFormOpenLink.addEventListener(`click`, () => {
        this.event('SignUpReviewClick');
        this.activeModal = this.MODAL_APARTMENTS_VIEW_FORM;
      });
  }

  closeModalHandler() {
    this.modalCloseButton.forEach((button) => {
      button.addEventListener(`click`, () => {
        switch (this.activeModal) {
          case this.MODAL_MENU:
            this.event('EndClick');
            break;
          case this.MODAL_PRESENTATION_FORM:
            this.event('FinishPresentatClick');
            break;
          case this.MODAL_PRESENTATION_VIDEO:
            this.event('ENDCLICKVIDEO');
            break;
        }

        this.activeModal = null;
      });
    });
  }
}
